import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const ReferralList = Loadable(lazy(() => import('./ReferralList')));
const AddReferral = Loadable(lazy(() => import('./AddReferral')));
const PrivateRoute = Loadable(lazy(() => import('../../auth/PrivateRoute')));

const ReferralRoutes = [
  {
    path: '/referral/list',
    element: (
      //<PrivateRoute pageUrl="ReferralMaster" requiredFunc="VIE">
        <ReferralList />
      //</PrivateRoute>
    ),
    auth: authRoles.admin,
  },
  {
    path: '/referral/manage',
    element: (
      <PrivateRoute pageUrl="ReferralMaster" requiredFunc="ADD">
        <AddReferral />
      </PrivateRoute>
    ),
    auth: authRoles.admin,
  },
];

export default ReferralRoutes;
